<template>
  <div style="padding: 0 1rem">
    <b-row style="min-height: calc(100vh - 40px)">
      <b-col sm="12" lg="8" style="display: flex">
        <div class="center">
          <b-row style="margin: 0px">
            <h1 style="font-weight: 600">
              Uji Coba Ground Check Anomali Dengan Platform Satu Data Kependudukan Indonesia (SDPI)
            </h1>
            <p class="text-muted" style="padding-bottom: 2rem">
              Pelaksanaan uji coba ground check anomali di Desa Gunung Medan dan
              Sungai Duo Kabupaten Dharmasraya Provinsi Sumatera Barat.
              Kelurahan Bungo Barat Kabupaten Bungo Provinsi Jambi, dan Desa
              Sukajaya Kabupaten Sumedang Provinsi Jawa Barat.
            </p>
          </b-row>
        </div>
      </b-col>
      <b-col class="bg-sdpi" sm="12" lg="4"> </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data: () => {
    return {};
  },
  methods: {},
};
</script>
